import { describeCarts } from "@/utils/deleteUploadGuarded";
import type { CartRef } from "@/utils/types/types";
import { Badge, Tooltip } from "@mantine/core";

// "In cart" indicator for the uploads lists (2026-09-03). Shown when a live,
// un-ordered cart references the file — the file must not be deleted while
// this is visible. Order badges (usedInOrders) are a separate, historical
// signal; a file can legitimately show both.
export function InCartBadge({
  inCarts,
  size = "sm",
}: {
  inCarts: CartRef[] | undefined;
  size?: "xs" | "sm";
}) {
  if (!inCarts || inCarts.length === 0) return null;
  const label =
    inCarts.length === 1
      ? `In cart${inCarts[0].name ? `: ${inCarts[0].name}` : ""}`
      : `In ${inCarts.length} carts`;
  return (
    <Tooltip
      label={`Do not delete — ${describeCarts(inCarts)} still uses this file.`}
      multiline
      w={280}
      withArrow
    >
      {/* Same default (theme) color as the order badges — Michael 09-03:
          orange/red reads as an error; this is information, not a warning. */}
      <Badge
        variant="light"
        size={size}
        radius="sm"
        style={{ textTransform: "none", cursor: "help" }}
      >
        {label}
      </Badge>
    </Tooltip>
  );
}
